import { createContext, useContext } from "react";

import type { components } from "../generated/forms-api";

export type AnswerSuggestion = components["schemas"]["AnswerSuggestion"];

export type PrefillDocument = {
    key: string;
    name: string;
    size: number;
    open: () => void;
    remove: () => Promise<void>;
};

export type Prefill = {
    documents: PrefillDocument[];
    add: (files: File[]) => Promise<AnswerSuggestion[]>;
};

export const PREFILL_EXTENSIONS = [".pdf", ".png", ".jpg", ".jpeg", ".txt"];
export const PREFILL_MAX_FILES = 5;
export const PREFILL_MAX_BYTES = 20 * 1024 * 1024;

export const prefillAccepts = (fileName: string) =>
    PREFILL_EXTENSIONS.includes(fileName.substring(fileName.lastIndexOf(".")).toLowerCase());

export type Review = { suggestion: AnswerSuggestion; status: "pending" | "confirmed" | "edited" };

export type Suggestions = {
    applicable: (suggestions: AnswerSuggestion[]) => AnswerSuggestion[];
    apply: (suggestions: AnswerSuggestion[]) => number;
    prompting: (questionKey: string, open: boolean) => void;
};

export const SuggestionsContext = createContext<Suggestions | undefined>(undefined);

export const useSuggestions = () => useContext(SuggestionsContext);
